import { Link } from "react-router-dom";
import { ArrowLeft, RefreshCcw } from "lucide-react";
import usePageTitle from "@/hooks/usePageTitle";

export default function RefundPolicyPage() {
  usePageTitle("pageTitles.refund");
  return (
    <div
      className="min-h-screen bg-slate-950 text-slate-100"
      data-testid="refund-policy-page"
    >
      <div className="max-w-3xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm text-slate-400 hover:text-amber-400 transition-colors mb-8"
          data-testid="refund-policy-page-back-link"
        >
          <ArrowLeft className="h-4 w-4" /> Back to home
        </Link>

        <div className="flex items-center gap-3 mb-6">
          <div className="w-11 h-11 rounded-full bg-gradient-to-br from-amber-500 to-orange-500 flex items-center justify-center text-slate-950">
            <RefreshCcw className="h-5 w-5" />
          </div>
          <h1 className="text-3xl sm:text-4xl font-bold text-white">
            Refund &amp; Cancellation Policy
          </h1>
        </div>

        <p className="text-xs uppercase tracking-wider text-amber-400 mb-8">
          Effective Date: September 30, 2026
        </p>

        <div className="space-y-6 text-slate-300 leading-relaxed">
          <section className="space-y-2">
            <h2 className="text-xl font-semibold text-white">
              Cancellation Policy
            </h2>
            <p>
              You may cancel your subscription at any time via your account
              dashboard or by emailing{" "}
              <a
                href="mailto:admin@kritajnaventures.com"
                className="text-amber-400 hover:underline"
              >
                admin@kritajnaventures.com
              </a>
              . Cancellations must occur before the next billing cycle. You
              retain access until the end of your paid period.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-xl font-semibold text-white">Refund Policy</h2>
            <p>
              Because PlateProfit provides immediate digital access,
              subscription fees are strictly{" "}
              <strong className="text-white">non-refundable</strong>. We do not
              provide pro-rated refunds for partial-month usage. Exceptions may
              be granted solely at our discretion for documented billing errors
              or prolonged technical outages if reported within{" "}
              <strong className="text-white">7 days</strong>.
            </p>
          </section>

          <p className="text-xs text-slate-500 pt-6 border-t border-slate-800">
            Questions? Contact{" "}
            <a
              href="mailto:admin@kritajnaventures.com"
              className="text-amber-400 hover:underline"
            >
              admin@kritajnaventures.com
            </a>
            .
          </p>
        </div>
      </div>
    </div>
  );
}
